import {Component, OnInit, AfterViewInit, PLATFORM_ID, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DOCUMENT} from "@angular/common";
import { isPlatformBrowser } from '@angular/common';
@Component({
    selector: 'app-fad-personal',
    templateUrl: './fad-personal.component.html',
    styleUrls: ['./fad-personal.component.scss']
})
export class FadPersonalComponent implements  OnInit {
    private userData: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    contactForm: any;
    constructor(
        private sessionService: SessionService,
        private router: Router,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(DOCUMENT) private document: any
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
    }


    callForm(type, isAdd?: boolean): void {
        // this.dialogService.showFormDialog(type);
        // tslint:disable-next-line:no-shadowed-variable
        let data: PaymentData;
        switch (type) {
            case 1:
                if (this.sessionService.getCountryData()) {
                    data = {
                        product: 'FAD® PERSONAL',
                        subscription: 'Suscripción mensual',
                        type: 'month',
                        quantity: 1,
                        usuarios: 1,
                        usuariosLabel: 'Usuario incluído',
                        /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                        transactions: '1000',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 199,
                        pricingInfo: 'MXP',
                        complements: [...Constants.defaultComplementsP]
                    };
                } else {
                    data = {
                        product: 'FAD® PERSONAL',
                        subscription: 'Suscripción mensual',
                        type: 'month',
                        quantity: 1,
                        usuarios: 1,
                        usuariosLabel: 'Usuario incluído',
                        /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                        transactions: '1000',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 9.9,
                        pricingInfo: 'USD',
                        complements: [...Constants.defaultComplementsP]
                    };
                }
                this.addDataLayerPersonal(data);
                break;
            case 2:
                if (this.sessionService.getCountryData()) {
                    data = {
                        product: 'FAD® PERSONAL',
                        subscription: 'Prepago con vigencia anual',
                        type: 'anual',
                        quantity: 1,
                        usuarios: 1,
                        usuariosLabel: 'Usuario incluído',
                        transactions: '10',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 200,
                        pricingInfo: 'MXP',
                        complements: [...Constants.defaultComplementsP]
                    };
                } else {
                    data = {
                        product: 'FAD® PERSONAL',
                        subscription: 'Prepago con vigencia anual',
                        type: 'anual',
                        quantity: 1,
                        usuarios: 1,
                        usuariosLabel: 'Usuario incluído',
                        transactions: '10',
                        transactionType: 'Video acuerdo + Video firma + Constancia de conservación',
                        pricing: 10,
                        pricingInfo: 'USD',
                        complements: [...Constants.defaultComplementsP]
                    };
                }
                this.addDataLayerPersonal(data);
                break;
        }

        if (this.userData === null) {
            /*
            if (isAdd) {
                this.sessionService.updateCartList(data, true);
            } else {
                const itemExist = this.sessionService.getCartItems().find(
                    item => item.product === data.product && item.subscription === data.subscription
                );
                if (itemExist) {
                    this.sessionService.setPaymentData(data);
                    this.router.navigate(['/comprar-firma-digital']);
                } else {
                    if (this.sessionService.getCartItems().length === 0) {
                        this.sessionService.updateCartList(data, true);
                        this.sessionService.setPaymentData(data);
                        this.router.navigate(['/comprar-firma-digital']);
                    } else {
                        this.dialogService.showNotificationDialog('Ups!', ' No puedes combinar paquetes.');
                    }
                }
            }*/
        } else {
            if (this.userData.isCompany === false) {
                if (isAdd) {
                    this.sessionService.updateCartList(data, true);
                } else {
                    const itemExist = this.sessionService.getCartItems().find(
                        item => item.product === data.product && item.subscription === data.subscription
                    );
                    if (itemExist) {
                        this.sessionService.setPaymentData(data);
                       this.router.navigate(['/comprar-firma-digital']);
                    } else {
                        if (this.sessionService.getCartItems().length === 0) {
                            this.sessionService.updateCartList(data, true);
                            this.sessionService.setPaymentData(data);
                         this.router.navigate(['/comprar-firma-digital']);
                        } else {
                            this.dialogService.showNotificationDialog('Ups!', ' No puedes combinar paquetes.');
                        }
                    }
                }
            } else {
                this.dialogService.showNotificationDialog('Tu cuenta es empresarial', 'No puedes agregar este producto, necesitas una cuenta personal.');
            }
        }
     
    }

    form(type):void{
        switch (type) {
            case 6:
                this.contactForm = 6;
                if (this.isMobile === true || this.isTablet === true) {
                    document.querySelector('#contact-cotizar-movil').scrollIntoView();
                } else {
                    document.querySelector('#contact-cotizar').scrollIntoView();
                }
                break;
            case 7:
                    this.contactForm = 7;
                    if (this.isMobile === true || this.isTablet === true) {
                        document.querySelector('#contact-cotizar-movil').scrollIntoView();
                    } else {
                        document.querySelector('#contact-cotizar').scrollIntoView();
                    }
                break;
        }

    }
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {

            const ancla = sessionStorage.getItem('ancla');
            sessionStorage.removeItem('ancla');
            console.log(ancla)
            const scrollTo = ancla ? ancla : 'inicio';
        
            // Verificar si el elemento con el ID existe en el DOM
            const targetElement = this.document.getElementById(scrollTo);
            console.log(targetElement)
            if (targetElement) {
              setTimeout(() => {
                targetElement.scrollIntoView({
                  behavior: "instant",
                  block: "start",
                  inline: "nearest"
                });
              }, 300);
            }
          }
        this.addDataLayer();
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'impressionView',
            ecommerce: {
                currencyCode: 'MXN',
                impressions: [
                    {
                        name: 'FAD® Firma - Plan personal - Suscripción Mensual',
                        id: 'FADPPSM',
                        price: '199',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        variant: 'Suscripcion Ilimitada',
                        list: 'FAD® Firma - Plan Personal',
                        position: 1
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA10',
                        price: '200',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        list: 'FAD® Firma - Plan Personal',
                        variant: 'Anual 10',
                        position: 2
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA20',
                        price: '360',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        list: 'FAD® Firma - Plan Personal',
                        variant: 'Anual 20',
                        position: 3
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA50',
                        price: '800',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        list: 'FAD® Firma - Plan Personal',
                        variant: 'Anual 50',
                        position: 4
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA100',
                        price: '1500',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        list: 'FAD® Firma - Plan Personal',
                        variant: 'Anual 100',
                        position: 5
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA200',
                        price: '2800',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        list: 'FAD® Firma - Plan Personal',
                        variant: 'Anual 200',
                        position: 6
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA500',
                        price: '6500',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        variant: 'Anual 500',
                        list: 'FAD® Firma - Plan Personal',
                        position: 8
                    },
                    {
                        name: 'FAD® Firma - Plan personal - Prepago anual',
                        id: 'FADPPPA10000',
                        price: '12000',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        variant: 'Anual 1000',
                        list: 'FAD® Firma - Plan Personal',
                        position: 9
                    }
                ]
            }
        });
    }

    addDataLayerPersonal(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        if (item.type === 'month') {
            // @ts-ignore
            dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'MXN',
                    add: {                                // 'add' actionFieldObject measures.
                        products: [{                        //  adding a product to a shopping cart.
                            name: 'FAD® Firma - Plan personal - Suscripción Mensual',
                            id: 'FADPPSM',
                            price: '199',
                            brand: 'FAD®',
                            category: 'FAD® Personal',
                            variant: 'Suscripcion Ilimitada',
                            position: 1
                        }]
                    }
                }
            });
        } else {
            // @ts-ignore
            dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'MXN',
                    add: {                                // 'add' actionFieldObject measures.
                        products: [{                        //  adding a product to a shopping cart.
                            name: 'FAD® Firma - Plan personal - Prepago anual',                      // Name or ID is required.
                            id: 'FADPPPA' + item.transactions,
                            price: item.pricing,
                            brand: 'FAD®',
                            category: 'FAD® Personal',
                            variant: 'Anual ' + item.transactions,
                            position: 2
                        }]
                    }
                }
            });
        }
    }

}
